import { useEffect } from "react";
import type { ShellUser } from "../../../api/types";
import { setExceptionMonitoringUserContext } from "../../../exceptionMonitoring";

export const useExceptionMonitoringUser = (user?: ShellUser | null) =>
  useEffect(() => {
    if (user) {
      setExceptionMonitoringUserContext(user, {});
    }
  }, [user]);
